import initModal from "./modals";
import playVideoInView from "./video-in-view";
import Rellax from "rellax";
import addScrollReveal from "./scrollreveal";
import activateScrollSpy from "./scrollSpy";
import initObjectsTable from "./datatables";
import initTabs from "./tabs";
import { buildingSlider } from "./sliders";
import initMasonry from "./gallery";
import openGalleriesModal from "./gallery-modal";
import $ from "jquery";
import { triggerHeaderOutOfView } from "./observers";
import initCookie from "./cookie";
import initLocationsMap from "./map";

addScrollReveal();
initLocationsMap();

triggerHeaderOutOfView();

initModal();
playVideoInView();
activateScrollSpy();

buildingSlider();
initMasonry();
openGalleriesModal();
// initCookie();

function initRellax() {
  const isPresent = document.querySelector(".rellax");
  if (!isPresent) {
    return;
  }

  var rellax = new Rellax(".rellax");

  const belowMDScreen = window.matchMedia("(max-width: 1023px)");

  belowMDScreen.addListener(handleScreenChange);

  function handleScreenChange(e) {
    if (e.matches) {
      rellax.destroy();
    } else {
      rellax.refresh();
    }
  }

  handleScreenChange(belowMDScreen);
}

initRellax();

initObjectsTable();
initTabs();

function triggerMenuOpen() {
  const isPresent = document.querySelector(".open-menu");
  if (!isPresent) {
    return;
  }

  const menuBtns = document.querySelectorAll(".open-menu");
  const menu = document.querySelector(".menu-container");
  const closeMenus = document.querySelectorAll(".menu-close");

  // menuBtn.addEventListener("click", function () {
  //   menuBtn.classList.add("opacity-0");
  //   menu.classList.add("open");
  // });

  menuBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      menuBtns.forEach((btn) => {
        btn.classList.add("opacity-0");
      });
      menu.classList.add("open");
    });
  });

  // closeMenu.addEventListener("click", function () {
  //   menuBtn.classList.remove("opacity-0");
  //   menu.classList.remove("open");
  // });

  closeMenus.forEach((closeMenu) => {
    closeMenu.addEventListener("click", function () {
      menuBtns.forEach((btn) => {
        btn.classList.remove("opacity-0");
      });
      menu.classList.remove("open");
    });
  });

  function documentClick(e) {
    if (
      !e.target.closest(".open-menu")
      // &&
      // !e.target.closest(".menu-container a")
    ) {
      // closeMenu.click();
      closeMenus.forEach((closeMenu) => {
        closeMenu.click();
      });
    }
  }

  if (menu.classList.contains("open")) {
    document.addEventListener("click", documentClick);
  } else {
    document.addEventListener("click", documentClick);
  }
}

triggerMenuOpen();

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height() / 4;

  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

$(window).scroll(function () {
  $(".js-slide").each(function () {
    if (isScrolledIntoView(this) === true) {
      $(this).addClass("object-visible");
    }
  });
});

function setItemMargins() {
  const isPresent = document.querySelector(".set-margins");
  if (!isPresent) {
    return;
  }

  const items = document.querySelectorAll(".set-margins");

  items.forEach((item) => {
    const itemHeight = item.offsetHeight;

    item.style.marginTop = `-${itemHeight / 3}px`;
  });
}

setItemMargins();
